export default __webpack_public_path__ + "static/2013-32cf119cc1c516d3dcd8994de71ab238.svg";